import Vue from 'vue'
import App from './App.vue'
import store from './store'
import axios from 'axios'
import lodash from 'lodash'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

new Vue({
  store,
  lodash,
  render: h => h(App)
}).$mount('#app')